import { create } from "zustand";
import { NoteSelectionGroup } from "../utils/NoteSelectionGroup";
import { JSX } from "react";


// FIXME: this name is definitely not helpful.
export type InputPlaneStore = {
    isInputPlaneOpen: boolean;
    toggleInputPlane: () => void;
    noteSelectionGroups: Map<number, NoteSelectionGroup>;
    setNoteSelectionGroups: (group: Map<number, NoteSelectionGroup>) => void;
    instrumentWidget?: JSX.Element;
    setInstrumentWidget: (widget: JSX.Element | undefined) => void;
}

export const inputPlaneStore = create<InputPlaneStore>((set) => ({
    isInputPlaneOpen: false,
    toggleInputPlane: () => set((state) => ({ isInputPlaneOpen: !state.isInputPlaneOpen })),
    noteSelectionGroups: new Map(),
    setNoteSelectionGroups: (groups) => set({ noteSelectionGroups: groups }),
    instrumentWidget: undefined,
    setInstrumentWidget: (widget) => set({ instrumentWidget: widget }),
}));

export const useInputPlaneStore = () => {
    return inputPlaneStore((state) => ({
        isInputPlaneOpen: state.isInputPlaneOpen,
        toggleInputPlane: state.toggleInputPlane,
        noteSelectionGroups: state.noteSelectionGroups,
        setNoteSelectionGroups: state.setNoteSelectionGroups,
        instrumentWidget: state.instrumentWidget,
        setInstrumentWidget: state.setInstrumentWidget,
    }));
}
export const useInputPlaneOpen = () => {
    return inputPlaneStore((state) => state.isInputPlaneOpen);
}
export const useInputPlaneToggle = () => {
    return inputPlaneStore((state) => state.toggleInputPlane);
}
export const useNoteSelectionGroups = () => {
    return inputPlaneStore((state) => state.noteSelectionGroups);
}
export const useSetNoteSelectionGroups = () => {
    return inputPlaneStore((state) => state.setNoteSelectionGroups);
}

export const useInstrumentWidget = () => {
    return inputPlaneStore((state) => state.instrumentWidget);
}
export const useSetInstrumentWidget = () => {
    return inputPlaneStore((state) => state.setInstrumentWidget);
}

export const useInputPlane = () => {
    return inputPlaneStore((state) => ({
        isInputPlaneOpen: state.isInputPlaneOpen,
        toggleInputPlane: state.toggleInputPlane,
        noteSelectionGroups: state.noteSelectionGroups,
        setNoteSelectionGroups: state.setNoteSelectionGroups,
    }));
}